rjm.ui.ChartBuilderChartStyleView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "click #cbChartStyleSelector button": "changeChartStyle"
    "click #grouperDeleteWarningCancel": "warningCancel"
    "click #grouperDeleteWarningContinue": "warningContinue"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderChartStyleView"

    _.bindAll @, "disableStyle", "enableStyle", "changeChartStyle", "warningContinue", "warningCancel", "generateTemplateData", "setDefaultStyle", "updateSelectedStyle", "handleCohortChart", "render"
    @chartModel = options.chartModel
    @setDefaultStyle()

    @listenTo @chartModel.getCurrentSeries(), "change:trend", => 
      @setDefaultStyle()
      @handleCohortChart()
    @listenTo @chartModel, "standard cohort", @handleCohortChart
    @listenTo @chartModel, "change:timeInterval", @updateSelectedStyle
    @listenTo @chartModel.getCurrentSeries().get("categorySet"), "change:categorySelector remove:categorySelectors", @updateSelectedStyle
    @listenTo @chartModel, "change:api_conn_id", @block
    @listenTo @chartModel.getCurrentSeries(), "change:trend", @unblock

    return

  disableStyle: (style) ->
    @$('button[data-id='+style+']').addClass('disabled')

  enableStyle: (style) ->
    @$('button[data-id='+style+']').removeClass('disabled')

  changeChartStyle: (e) ->
    element = if @$(e.target).is('i') then @$(e.target).parent() else @$(e.target)
    if element.hasClass('disabled')
      return false

    newStyle = @$(element).attr("data-id")

    if newStyle is "SCALAR" and @chartModel.get("series").at(0).get("categorySet").get("categorySelectors").size() > 0
      @$('#grouperDeleteWarning').modal "show" #handle this edge case via the modal and warningContinue
      return

    #This logic should be on the chart model so in the future it can be used from more than just this view
    if newStyle is "SCALAR"
      @chartModel.set 
        chartStyle: rjm.app.enums.chartStyle.SCALAR
        timeInterval: null
        isTimeOnXAxis: false
    else if newStyle is "TABLE"
      @chartModel.set {chartStyle: rjm.app.enums.chartStyle.TABLE}, {silent: true}
      @chartModel.change()
    else
      @chartModel.set
        chartStyle: rjm.app.enums.chartStyle[newStyle]

    return

  warningContinue: (e) ->
    e.preventDefault()
    @$('#grouperDeleteWarning').modal "hide"
    @chartModel.get('series').at(0).get("categorySet").removeAllCategories();
    @chartModel.set 
        chartStyle: rjm.app.enums.chartStyle.SCALAR
        isTimeOnXAxis: false
    if not (@chartModel.hasChanged("chartstyle") or @chartModel.hasChanged("isTimeOnXAxis"))
      @chartModel.trigger "change", @chartModel #manually fire the change event when the chartstyle or time on axis hasn't changed
    @render()

  warningCancel: (e) ->
    e.preventDefault()
    @$('#grouperDeleteWarning').modal "hide"
    @$('button[data-id=SCALAR]').removeClass('active')
    @$('button[data-id=' + @chartModel.get("chartStyle").serializedValue + ']').addClass('active')

  generateTemplateData: ->
    # Needs Refactor since I broke out of the enum on chartBuilderChartStyle.tpl - Matt
    chartStyleEnums: rjm.app.enums.chartStyle
    propertyName: "names"
    selectedChartStyle: @chartModel.get("chartStyle").serializedValue

  setDefaultStyle: ->
    if @chartModel.get("id")?
      return
    # If we don't have a timestamp, table and scalar are the only acceptable styles
    currentStyle = @chartModel.get("chartStyle")
    if not @chartModel.hasTimestamp() and currentStyle isnt rjm.app.enums.chartStyle.TABLE and currentStyle isnt rjm.app.enums.chartStyle.SCALAR
      @chartModel.set chartStyle: rjm.app.enums.chartStyle.TABLE
      @$('.active').removeClass('active')
      @$('button[data-id=' + @chartModel.get("chartStyle").serializedValue + ']').addClass('active')
    return

  updateSelectedStyle: ->
    @$('.active').removeClass('active')
    if @chartModel.get("chartStyle") is rjm.app.enums.chartStyle.SCALAR and  
        (@chartModel.get('series').at(0).get("categorySet").hasSelectors() or @chartModel.get("isTimeOnXAxis"))
      @chartModel.set
        chartStyle: rjm.app.enums.chartStyle.TABLE
    
    @$('button[data-id=' + @chartModel.get("chartStyle").serializedValue + ']').addClass('active')

  handleCohortChart: ->
    if @chartModel.isCohortChart()
      @disableStyle('SCALAR')
      @disableStyle('PIE_CHART')
    else
      @enableStyle('SCALAR')
      @enableStyle('PIE_CHART')

    return

  render: ->
    @$el.html ich.chartBuilderChartStyle(@generateTemplateData())
    @updateSelectedStyle()
    @handleCohortChart()

    return @
)
